import { render, staticRenderFns } from "./PricingSelection.vue?vue&type=template&id=923159ca&scoped=true"
import script from "./PricingSelection.vue?vue&type=script&lang=js"
export * from "./PricingSelection.vue?vue&type=script&lang=js"
import style0 from "./PricingSelection.vue?vue&type=style&index=0&id=923159ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923159ca",
  null
  
)

/* custom blocks */
import block0 from "./PricingSelection.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports